import { createAction } from '@reduxjs/toolkit'
import {
  grhActiveOptionsType,
  grhTransactionUsesType,
  micromobilityActiveOptionsType,
  flexActiveOptionsType,
  qtfBenefitsType,
  qtfPayrollScheduleType,
  BudgetCycle,
  TransitPassPurchaseType,
  TransitPassDeliveryMechanism,
} from '../Shared/types'

const changeGrhTransactionUses = createAction<{
  type: grhTransactionUsesType
  value: number
}>('programEditing/changeGrhTransactionUses')

const changeGrhActiveOptions = createAction<{
  type: grhActiveOptionsType
  value: boolean
}>('programEditing/changeGrhActiveOptions')

const changeGrhActiveMerchantIds = createAction<{
  type: grhActiveOptionsType
  value: string[]
}>('programEditing/changeGrhActiveMerchantIds')

const changeMicromobilityBudget = createAction<number>(
  'programEditing/changeMicromobilityBudget'
)

const changeMicromobilityActiveOptions = createAction<{
  type: micromobilityActiveOptionsType
  value: boolean
}>('programEditing/changeMicromobilityActiveOptions')

const changeMicromobilityActiveMerchantIds = createAction<{
  type: micromobilityActiveOptionsType
  value: string[]
}>('programEditing/changeMicromobilityActiveMerchantIds')

const changeFlexBudget = createAction<number>('programEditing/changeFlexBudget')

const changeFlexBudgetCycle = createAction<BudgetCycle>(
  'programEditing/changeFlexBudgetCycle'
)

const changeFlexOneTimePurchase = createAction<boolean>(
  'programEditing/changeFlexOneTimePurchase'
)

const changeFlexRolloverBudget = createAction<boolean>(
  'programEditing/changeFlexRolloverBudget'
)

const changeFlexActiveOptions = createAction<{
  type: flexActiveOptionsType
  value: boolean
}>('programEditing/changeFlexActiveOptions')

const changeFlexActiveMerchantIds = createAction<{
  type: flexActiveOptionsType
  value: string[]
}>('programEditing/changeFlexActiveMerchantIds')

const changeTransitPassPurchaseType = createAction<TransitPassPurchaseType>(
  'programEditing/changeTransitPassPurchaseType'
)

const changeTransitPassWalletTopUpEnabled = createAction<boolean>(
  'programEditing/changeTransitPassWalletTopUpEnabled'
)

const changeTransitPassBudget = createAction<number>(
  'programEditing/changeTransitPassBudget'
)

const changeTransitPassDeliveryMechanism =
  createAction<TransitPassDeliveryMechanism>(
    'programEditing/changeTransitPassDeliveryMechanism'
  )

const changeTransitPassAgencyIds = createAction<string[]>(
  'programEditing/changeTransitPassAgencyIds'
)

const changeTransitPassAgenciesEnabled = createAction<boolean>(
  'programEditing/changeTransitPassAgenciesEnabled'
)

const getTransitAgencies = createAction('programEditing/getTransitAgencies')

const changeCouponMerchantIds = createAction<string[]>(
  'programEditing/changeCouponMerchantIds'
)

const changeCouponMerchantsEnabled = createAction<boolean>(
  'programEditing/changeCouponMerchantsEnabled'
)

const getCouponMerchants = createAction('programEditing/getCouponMerchants')

const changeCouponCode = createAction<string>('programEditing/changeCouponCode')

const changeReportedUsageMerchants = createAction<string[]>(
  'programEditing/changeReportedUsageMerchants'
)

const changeQtfBenefits = createAction<{
  type: qtfBenefitsType
  value: boolean
}>('programEditing/changeQtfBenefits')

const changeQtfEmployerContributions = createAction<{
  type: qtfBenefitsType
  value: number
}>('programEditing/changeQtfEmployerContributions')

const changeQtfFinalizeAllocation = createAction<number>(
  'programEditing/changeQtfFinalizeAllocation'
)

const changeQtfPayrollSchedule = createAction<qtfPayrollScheduleType>(
  'programEditing/changeQtfPayrollSchedule'
)

const changeQtfMaxAllocationLimit = createAction<{
  type: qtfBenefitsType
  value: number | null
}>('programEditing/changeQtfMaxAllocationLimit')

const applyRehydrateState = createAction<any>(
  'programEditing/applyRehydrateState'
)

const clearState = createAction('programEditing/clearState')

const getGovernmentGrhPrograms = createAction(
  'programEditing/getGovernmentGrhPrograms'
)

export const programEditingActions = {
  changeGrhTransactionUses,
  changeGrhActiveOptions,
  changeGrhActiveMerchantIds,
  changeMicromobilityBudget,
  changeMicromobilityActiveOptions,
  changeMicromobilityActiveMerchantIds,
  changeFlexBudget,
  changeFlexBudgetCycle,
  changeFlexOneTimePurchase,
  changeFlexRolloverBudget,
  changeFlexActiveOptions,
  changeFlexActiveMerchantIds,
  changeTransitPassPurchaseType,
  changeTransitPassWalletTopUpEnabled,
  changeTransitPassBudget,
  changeTransitPassDeliveryMechanism,
  changeTransitPassAgencyIds,
  changeTransitPassAgenciesEnabled,
  getTransitAgencies,
  changeCouponMerchantIds,
  changeCouponMerchantsEnabled,
  getCouponMerchants,
  changeCouponCode,
  changeReportedUsageMerchants,
  changeQtfBenefits,
  changeQtfEmployerContributions,
  changeQtfFinalizeAllocation,
  changeQtfPayrollSchedule,
  changeQtfMaxAllocationLimit,
  applyRehydrateState,
  clearState,
  getGovernmentGrhPrograms,
}
